import parseCookies from 'lib/cookie/parser';
import dispatchEvent from '../analytics/dispatchEvent';
import addPageAction from '../analytics/addPageAction';

const MONETATE_COOKIE = 'mt.v';
const MONETATE_IMPRESSION = 'monetate:record:Impressions';

const getExperienceByImpressionId = (id, monetateExperiences) => {
  const experiences = monetateExperiences || [];
  return experiences.find(
    experience => experience.experienceName.indexOf(id) > -1
  );
};

const postMonetateImpression = async (
  monetate,
  id,
  monetateExperiences = []
) => {
  const experience = getExperienceByImpressionId(id, monetateExperiences);
  if (experience) {
    const impressionRecord = {
      channel: monetate.channel,
      monetateId: parseCookies()[MONETATE_COOKIE] || null,
      events: [
        {
          eventType: MONETATE_IMPRESSION,
          impressionIds: [experience.impressionId],
        },
      ],
    };

    try {
      // Monetate postback
      await fetch(monetate.url, {
        method: 'POST',
        body: JSON.stringify(impressionRecord),
      });
      // Omniture postback
      dispatchEvent('dataStateChange', {
        action: 'managedImpression',
        campaigns: [
          {
            id: experience.impressionId,
            key: experience.experienceName,
            reports: [],
            split: experience.variantLabel,
          },
        ],
      });
      addPageAction(window, 'managedImpression', {
        id: experience.impressionId,
        split: experience.variantLabel,
        info: 'both fired',
      });
    } catch (e) {
      addPageAction(window, 'managedImpression', {
        id: experience.impressionId,
        split: experience.variantLabel,
        info: 'monetate failed',
      });

      // eslint-disable-next-line no-console
      console.error(e.message);
    }
  }
};

export default postMonetateImpression;
